var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.classes},[(_vm.preloading)?_c('v-container',{staticClass:"mt-10 pt-10",attrs:{"fluid":""}},[_c('MyLoader')],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }